import { RENDER_MODEL_IDS } from 'Pods/ThreeDStudio/Store/constants'

import { getAssetByTypeAndSource } from './getAssetByTypeAndSource'

export const isRenderRun = run => RENDER_MODEL_IDS.has(run?.providerModelId)

// The generated image among the run's outputs, like the Images library reads it, so an
// input or uploaded asset listed first can never stand in for the render.
const getRenderImageAsset = (run) => {
  const asset = getAssetByTypeAndSource(run?.outputAssets, 'image', 'ai_generated')

  return asset.fileUrl ? asset : null
}

// A render's output is the 2D image itself, so its thumbnail is read from the generated
// asset, never from whatever is listed first. Image assets are served without a
// previewUrl, so the file stands in.
export const getVariationPreviewUrl = (variation) => {
  if (!isRenderRun(variation)) {
    return variation?.outputAssets?.[0]?.previewUrl
  }

  const asset = getRenderImageAsset(variation)

  return asset?.previewUrl || asset?.fileUrl
}

// Whether the Render preview is showing this run's image.
export const isRenderPreviewOf = (run, renderPreview) => (
  renderPreview?.image?.id != null
  && isRenderRun(run)
  && getRenderImageAsset(run)?.assetId === renderPreview.image.id
)

/**
 * The ui.renderPreview payload for a finished render run, or null when it produced no image.
 * @param {Object} run - Run attributes, from the runs channel or useGetVariations
 * @returns {{ image: { id: number, url: string, alt?: string, slug?: string }, sessionId?: number } | null}
 */
export const buildRenderPreview = (run) => {
  const asset = getRenderImageAsset(run)

  if (!asset) {
    return null
  }

  return {
    image: { id: asset.assetId, url: asset.fileUrl, alt: run.prompt, slug: run.slug },
    sessionId: run.generatorSessionId,
  }
}
